import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import AdsPlansUpdated from '../ads-plans/AdsPlansUpdated';
import getFetchConfig from '../../../utils/getFetchConfig';
import handleFetchErrors from '../../../utils/handleFetchErrors';
import standardFetchHandlers from '../../../utils/standardFetchHandlers';
import formDataAppender from '../../../utils/formDataAppender';
import TimePicker from 'rc-time-picker';
import { Modal, Button } from 'react-bootstrap';
import ThankYouModal from '../updateScreen/ThankYouModal';

import {
    isTruthyString,
    isValidURL,
    isValidEmailAddress,
    isValidPassword,
    isValidYoutubURL,
    isValidIndianMobileNumber,
    isDescriptionHas5Words
} from '../../../utils/verification';
// import '../../../pages/test.css';
import cuid from 'cuid';
import MultiSelect from '../../form-input/MultiSelect';
import Timepicker from '../../form-input/Timepicker';
import RichTextEditor from '../../form-input/RichTextEditor';
import Inputs from '../../Inputs/Inputs';
import PostAdsHeading from '../post-ads-heading/PostAdsHeading';
import FormButton from '../../buttons/form-button/FormButton';
import AdsListerInfo from '../ads-lister-info/AdsListerInfo';
// import AdsPlans from '../ads-plans/AdsPlans';
import ContactDetails from '../contact-details/ContactDetails';
import SelectLocation from '../select-location/SelectLocation';
import ImageUpload from '../images-upload/ImageUpload';
import CongratulationsScreen from '../congratulations-screen/CongratulationsScreen';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import appURLs from '../../../appURL';
import style from "./localBizAndSservice.module.css";
import moment from 'moment';

export default function LocalBizAndServices({ toggleModalVisibilty = () => { }, onLocalBizChange, adsCategoriesId = ``, adsId = "", adsIds,  onStepChange, }) {

    const fetchConfig = getFetchConfig(),
        appURL = appURLs();
    const [locationResponseData, setLocationResponseData] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [myadsId, setmyadsId] = useState('');
    const [myadsType, setmyadsType] = useState('');
    const [dynamicData, updateDynamicData] = useState([]),
        [steps, updateSteps] = useState(0),
        [selectedTagline, upatedSelectedTagline] = useState([]),
        [updateCat, setupdateCat] = useState(''),
        [subCat, updateSubCat] = useState(''),
        [accreditationLists, updateAccreditationLists] = useState([]),
        [localbizANDservicesId, updateLocalbizANDservicesId] = useState(null),
        [showLoader, toggleLoader] = useState(false);
    const [weekdayTime, updateWeekdayTime] = useState({
        start: "",
        end: "",
    });
  
    const [error, setError] = useState('');
    const [forStart, setforStart] = useState('');
    const [forEnd, setforEnd] = useState('');

    const [forStartSend, setforStartSend] = useState('');
    const [forEndSend, setforEndSend] = useState('');
    const [showUpdateSuccessModal, setShowUpdateSuccessModal] = useState(false);
    // const [showSaveDraftModal, setShowSaveDraftModal] = useState(false);
    const [showExitConfirmModal, setShowExitConfirmModal] = useState(false); // First modal
    const [showSaveDraftModal, setShowSaveDraftModal] = useState(false);     // Second modal for draft
    const [showDeleteModal, setShowDeleteModal] = useState(false);           // Second modal for delete



    const [weekedTime, updateWeekedTime] = useState({
        start: "",
        end: "",
    });
    const [lat, setlat] = useState("")
    const [lng, setlng] = useState("");
    const now = moment().hour(20).minute(22);

    const [images, updateImage] = useState([]),
        [subCategory, updatesSubCategory] = useState([]),
        [formData, updateFormData] = useState({
            title: "",
            categories: "",
            profession: "",
            categories: "",
            sub_categories: "",
            video_link: "",
            appointment_link: "",
            buisness_name: "",
            tagline: [],
            experience: "",
            business_service: "",
            buisnesslocation: "",
            week_days: "",
            accreditation_file: [],
            accreditation_name: [],
            accreditation_document: [],
            isClaimed: false,
            price: null,
            availabilty_type: "",
            working_hours: "",
            Additional_info: "",
            descriptions: "",
            country_code: "+1",
            secondary_country_code: "+1",
            location: "",
            latitude: "",
            longitude: "",
            claim: false,
            name: JSON.parse(localStorage.getItem(`user`))?.name,
            email_address: JSON.parse(localStorage.getItem(`user`))?.email_address,
            primary_phone_number: JSON.parse(localStorage.getItem(`user`))?.phone_number,
            secondary_phone_number: "",
            hide_email_address: false,
            hide_phone_number: false,
            website_link: "",
            adsType: "",
            status: ""
        });

        useEffect(() => {
            if (onStepChange) {
              onStepChange(steps);
            }
          }, [steps, onStepChange]);

    const [tags, setTags] = useState([]);
    const [inputValue, setInputValue] = useState("");
    // Add this state with your existing state declarations
    const [showThankYouModal, setShowThankYouModal] = useState(false);

    // Handle typing in the input field (with character limit)
    const handleTagInputChange = (e) => {
        const value = e.target.value;
        if (value.length <= 25) {
            setInputValue(value);  // Only update the input if the length is <= 25
        }
    };

    // Handle adding a tag (either pressing Enter or clicking the Add button)
    const handleAddTag = () => {
        if (inputValue.trim() && !tags.includes(inputValue)) {
            updateFormData((prevData) => ({
                ...prevData,
                tagline: [...prevData.tagline, inputValue],  // Append to tagline array
            }));
            setTags([...tags, inputValue]);  // Add the tag to the list
            setInputValue("");  // Clear the input field
        }
    };

    // Handle tag removal
    const handleRemoveTag = (tagToRemove) => {
        setTags(tags.filter(tag => tag !== tagToRemove));  // Remove the tag from the list
    };

    // Handle the Enter key press
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            handleAddTag();
        }
    };

    const radioBtnOption = [
        {
            label: "Weekdays",
            value: "1",
        },
        {
            label: "Weekends",
            value: "2",
        },
        {
            label: "Weekdays & Weekends",
            value: "3",
        },
        {
            label: "24/7",
            value: "4",
        },
        {
            label: "By appointment",
            value: "5",
        }
    ]

    const {
        profession,
        categories,
        sub_categories,
        buisness_name,
        tagline,
        experience,
        business_service,
        buisnesslocation,

        descriptions,
        Additional_info,
        video_link,
        appointment_link,
        availabilty_type,
        week_days,
        working_hours,
        price,
        accreditation_name,
        accreditation_document,
        accreditation_file,

        location,
        location_name,
        latitude,
        longitude,
        title,
        status,
        country_code,
        name,
        claim,
        isClaimed,
        email_address,
        primary_phone_number,
        secondary_phone_number,
        hide_phone_number,
        hide_email_address,
        website_link,
        adsType
    } = formData;

    const onChangeHandlerForForm = (e) => {
        const inputName = e?.target?.name || e?.name,
            inputValue = e?.target?.value || e?.value;
        if (inputName === 'country_code') {
            updateFormData(prev => ({
                ...prev,
                country_code: inputValue
            }));
            return;
        }
        if (inputName === 'secondary_country_code') {
            updateFormData(prev => ({
                ...prev,
                secondary_country_code: inputValue
            }));
            return;
        }

        const inputChecked = e?.target?.checked;
        if (inputName === 'categories') {
            // Find the category object with the given ID
            const category = dynamicData.categories.find(cat => cat._id === inputValue);
            if (category) {
                // Extract subcategory names from the array of subcategory objects
                const subcategories = category.subcategory.map(subcat => subcat);
                updatesSubCategory(subcategories);

            } else {
                // If category not found, update with an empty array
                updatesSubCategory([]);
            }
        }
        if (inputName === 'isClaimed') {
            updateFormData((prev) => ({
                ...prev,
                [inputName]: inputChecked,
            }));
        }

        if (inputName === `primary_phone_number` || inputName === `secondary_phone_number`) {
            const inputNumber1 = e.target.value.replace(/\D/g, ""); // Remove non-digit characters

            if (inputNumber1.length <= 15) {
                updateFormData((prev) => ({
                    ...prev,
                    [inputName]: inputValue
                }));
            }
        } else {

            updateFormData((prev) => ({
                ...prev,
                [inputName]: e.target.type === 'checkbox' ? inputChecked : inputValue
            }));

        }

        if (availabilty_type === "1" || availabilty_type == '3' || availabilty_type == '4' || availabilty_type == '5') {
            updateWeekedTime({
                start: "",
                end: "",
            });

            toggleIs24HoursSelected({
                weekdend: false
            })
        }
        if (availabilty_type === "2" || availabilty_type == '3' || availabilty_type == '4' || availabilty_type == '5') {
            updateWeekdayTime({
                start: "",
                end: "",
            });

            toggleIs24HoursSelected({
                weekday: false
            })
        }
    }


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        toast.dismiss();

        localStorage.removeItem("start_date");
        localStorage.removeItem("end_date");

        if (steps === 4) return toggleModalVisibilty("localBizServices", false);

        const missingData = [],
            invalidData = [];

        if (steps === 0) {

            // if (categories === "Other - Enter your profession" && !isTruthyString(categories)) missingData.push(`Profession`);
            if (!isTruthyString(categories)) missingData.push(`Category`);
            if (subCategory && subCategory.length && !isTruthyString(sub_categories)) missingData.push(`${categories} category`)
            if (!isTruthyString(buisness_name)) missingData.push(`title`);
            // if (tagline && !isTruthyString(tagline)) missingData.push(`Tagline`);
            // if (!isTruthyString(location)) missingData.push(`Business location`);
            if (!isTruthyString(location_name)) missingData.push('Business location');
            else if (!locationResponseData && !adsIds) {
                return toast.error('Please select a location from the suggestions');
            }

            if (!isTruthyString(experience)) missingData.push(`Business experience`);

        } else if (steps === 1) {

            if (!availabilty_type) missingData.push("availabilty");

            if (availabilty_type) {
                if ((availabilty_type === "1" || availabilty_type === "3") && !is24HoursSelected?.weekday) {
                    if (!(weekdayTime?.start)) missingData.push(`${weekdayTime?.start}weekday start time`);
                    if (!(weekdayTime?.end)) missingData.push(`weekday end time`);
                    if ((weekdayTime?.start && weekdayTime?.end) && weekdayTime?.start === weekdayTime?.end) return toast.error(` weekday start time and end time can't be same`);
                }
                if ((availabilty_type && (availabilty_type === "2" || availabilty_type === "3")) && !is24HoursSelected?.weekdend) {

                    if (!(weekedTime?.start)) missingData.push(`weekend start time`);
                    if (!(weekedTime?.end)) missingData.push(`weekend end time`);
                    if ((weekedTime?.start && weekedTime?.end) && weekedTime?.start === weekedTime?.end) return toast.error(` weekend start time and end time can't be same`);
                }
            }

            if (video_link && !isValidYoutubURL(video_link)) invalidData.push(`Youtube video link`);
            // if (!isTruthyString(buisnesslocation)) missingData.push(`Business location`);

            if (!isTruthyString(descriptions)) missingData.push(`description`);
            else if (isDescriptionHas5Words(descriptions)) {
                return toast.error("You must write at least 5 words in your description");
            }
        } else if (steps === 2) {

            if (!(name || email_address || primary_phone_number || secondary_phone_number || primary_phone_number)) return toast.error(`Please provide all data`)

            if (!isTruthyString(name)) missingData.push(`Name`);
            if (!email_address) missingData.push(`Email address`);
            else if (email_address && !isValidEmailAddress(email_address)) invalidData.push(`Email address`);

            if (!primary_phone_number) missingData.push(`Primary phone number`);
            else if (primary_phone_number && isNaN(primary_phone_number)) invalidData.push(`Primary phone number`);
            else if (primary_phone_number && (primary_phone_number.length < 10 || primary_phone_number.length > 15)) invalidData.push(`Primary phone number`);

            if (secondary_phone_number && isNaN(secondary_phone_number)) invalidData.push(`Secondary phone number`);
            else if (secondary_phone_number && (secondary_phone_number.length < 10 || secondary_phone_number.length > 15)) invalidData.push(`secondary phone number`);

            if ((secondary_phone_number && secondary_phone_number) && primary_phone_number === secondary_phone_number) return toast.error(`Primary phone number can not be same as secondary phone number`)

        }

        // Show errors if needed
        if (missingData.length || invalidData.length) {
            if (missingData.length) toast.error(`Missing Data:- ${missingData.join(`, `)}`);
            if (invalidData.length) toast.error(`Invalid Data:- ${invalidData.join(`, `)}`);
            return;
        }
        // Close any open modals before proceeding
        setShowExitConfirmModal(false);
        setShowSaveDraftModal(false);
        setShowDeleteModal(false);

        if (steps == 2 && adsIds && status === "active") {
            setShowThankYouModal(true);
        }
        else if (steps !== 4) {
            updateSteps(steps + 1);
        }
        // else if (steps !== 4) {
        //     updateSteps(steps + 1);
        // }
        // // else if (steps !== 1 && steps !== 2) {
        // //     updateSteps(steps + 1);
        // // }

        // // if (steps == 2 && adsIds && status === "active") {
        // //     // toast.success("Ads Updated Successfully");
        // //     toggleModalVisibilty("localBizServices", false);
        // //     // window.location.reload();
        // // }

        // if (steps == 2 && adsIds && status === "active") {
        //     setShowThankYouModal(true); 

        //     return; 
        // }

        let formDataObj = {
            // adsType: `6418290f60a9d558ae7edf02`,
            // week_days:week_days,
            adsType: adsCategoriesId || adsType,
            categories: categories,
            sub_categories: sub_categories,
            // redirect_uri_success: "menehariya.netscapelabs.com/success",
            redirect_uri_success: "https://test.menehariya.com/success",
            isPromoted: false
        };

        if (buisness_name) formDataObj.business_name = buisness_name;
        if (tagline) formDataObj.tagline = tagline;
        if (experience) formDataObj.experience = experience

        if (price) formDataObj.price = price;
        if (Additional_info) formDataObj.Additional_info = Additional_info;
        if (descriptions) {
             console.log("descriptions sourabh", stripHtmlTags(descriptions));
              formDataObj.descriptions = descriptions; }
        if (video_link) formDataObj.video_link = video_link;

        if (availabilty_type) formDataObj.availabilty_type = availabilty_type;

        if (availabilty_type === "4") formDataObj.is_24_seven = true;
        if (availabilty_type === "5") formDataObj.is_appointment = true;

        // if 24 hours selected fro week day
        if (!weekdayTime.start && (!weekedTime?.start || !weekedTime?.end)) {
            formDataObj.week_day = true;
            formDataObj.weekday_open_at = "00:00:00";
            formDataObj.weekday_close_at = "24:00:00";
            formDataObj.weekday_24_hour = true;
        }

        const is12HourFormat = (timeString) => {
            const regex = /^(0?[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/;
            return regex.test(timeString);
        };
        const convertTimeFormat = (timeString) => {
            // Check if the time is already in 12-hour format with AM/PM
            if (is12HourFormat(timeString)) {
                return timeString;
            }

            // Parse the date string
            const date = new Date(timeString);

            // Get hours and minutes
            let hours = date.getHours();
            const minutes = date.getMinutes();

            // Determine AM or PM
            const ampm = hours >= 12 ? 'PM' : 'AM';

            // Convert 24-hour time to 12-hour time
            hours = hours % 12;
            hours = hours ? hours : 12; // The hour '0' should be '12'

            // Pad minutes with leading zero if necessary
            const minutesStr = minutes < 10 ? '0' + minutes : minutes;

            // Return the formatted time
            return `${hours}:${minutesStr} ${ampm}`;
        };

        if ((availabilty_type === "1" || availabilty_type === "3") && weekdayTime.start) {

            formDataObj.week_day = true;
            formDataObj.weekday_open_at = convertTimeFormat(weekdayTime.start);
            formDataObj.weekday_close_at = convertTimeFormat(weekdayTime.end);
            formDataObj.weekday_24_hour = false;
        }

        // if week day  is selected 


        // if 24 hours selected fro weekend day
        if (!weekedTime.start) {
            formDataObj.week_end = true;
            formDataObj.weekend_open_at = "00:00:00";
            formDataObj.weekend_close_at = "24:00:00";
            formDataObj.weekend_24_hour = true;
        }

        // if weekend day  is selected 
        if ((availabilty_type === "2" || availabilty_type === "3") && weekedTime.start) {
            formDataObj.week_end = true;
            formDataObj.weekend_open_at = convertTimeFormat(weekedTime.start);
            formDataObj.weekend_close_at = convertTimeFormat(weekedTime.end);
            formDataObj.weekend_24_hour = false;
        }

        if ((availabilty_type === "1" || availabilty_type === "3") && weekdayTime.start && weekedTime.start) {
            
            formDataObj.week_day = true;
            formDataObj.weekday_open_at = convertTimeFormat(weekdayTime.start);
            formDataObj.weekday_close_at = convertTimeFormat(weekdayTime.end);
            formDataObj.weekday_24_hour = false;


            formDataObj.week_end = true;
            formDataObj.weekend_open_at = convertTimeFormat(weekedTime.start);
            formDataObj.weekend_close_at = convertTimeFormat(weekedTime.end);
            formDataObj.weekend_24_hour = false;
        }

        // contact detail;
        if (location_name) formDataObj.location_name = location_name;
        if (latitude) formDataObj.latitude = latitude;
        if (longitude) formDataObj.longitude = longitude;
        // if(longitude) formDataObj.is_24_seven = true;


        if (accreditationLists && accreditationLists.length) {
            formDataObj.accreditation_name = accreditationLists.map((item) => item.name);
            // formDataObj.accreditation_document = accreditationLists.map((item) => item.file_name);
        }

        // lsiter detail;
        if (name) formDataObj.name = name;
        if (isClaimed) formDataObj.isClaimed = isClaimed;
        if (email_address) formDataObj.email_address = email_address;
        if (country_code) formDataObj.country_code = country_code;
        if (primary_phone_number) {
            formDataObj.primary_country_code = formData.country_code || "";
            formDataObj.primary_phone_number = primary_phone_number;
        }
        if (secondary_phone_number) {
            formDataObj.secondary_country_code = formData.secondary_country_code || "";
            formDataObj.secondary_phone_number = secondary_phone_number;
        }
        if (website_link) formDataObj.website_link = website_link;
        if (isHideMobileNumberChecked) formDataObj.hide_my_phone = isHideMobileNumberChecked;
        if (isHideEmailAddressChecked) formDataObj.hide_my_secondary_phone = isHideEmailAddressChecked;
        const localBizAndServiceFormData = new FormData();


        if ((adsId || adsIds) && status === 'draft') {
            // alert("infirsty")
            steps === 2 && selectedFiles.forEach((file, index) => {
                localBizAndServiceFormData.append('photos', file);
            })
        }
        else if (!((adsId || adsIds) && status === 'draft')) {
            // alert("insecond")
            steps === 2 && selectedFiles.forEach((file, index) => {
                localBizAndServiceFormData.append('photos', file);
            })
        }
        else if (status === 'active') {
            // alert("inthird")
            steps === 1 && selectedFiles.forEach((file, index) => {
                localBizAndServiceFormData.append('photos', file);
            })
        }

        function stripHtmlTags(html) {
            const temporaryElement = document.createElement('div');
            temporaryElement.innerHTML = html;
            return temporaryElement.textContent || "";
        }

        accreditationLists.forEach((file, index) => {
            if (file.image_file_obj instanceof File) {
                localBizAndServiceFormData.append('accreditation_document', file.image_file_obj);
            } else {
                console.error('image_file_obj is not a File object:', file.image_file_obj);
            }
        });

        const data = formDataAppender(formDataObj, selectedFiles, localBizAndServiceFormData);

        for (const pair of localBizAndServiceFormData.entries()) {
            console.log(`${pair[0]}, ${pair[1]}`);
        }

        if (steps === 1 && !localbizANDservicesId && !adsIds) {
            toggleLoader(true);

            const updatedFetchConfig = fetchConfig;
            delete updatedFetchConfig.headers['Content-Type'];

            fetch(`${appURL}/posts/biz/create-service`, {
                ...updatedFetchConfig,
                body: data
            })
                .then(handleFetchErrors)
                .then((res) => {
                    toggleLoader(false)
                    if (res?.status == 200) {
                        const data = res.bizAndServices
                        const localbizANDservicesObjectId = res?.bizAndServices?._id
                        updateFormData((prev) => ({ ...prev, claim: data.claim }));
                        updateSteps(steps + 1);
                        updateLocalbizANDservicesId(localbizANDservicesObjectId)
                        localStorage.setItem('adsInfo', JSON.stringify({
                            id: localbizANDservicesObjectId,
                            title: buisness_name,
                            adsType: "localbizANDservices",
                            adsCategories: adsCategoriesId
                        }));
                    } else {
                        return toast.error(res?.message);
                    }
                })
                .catch((err) => {
                    toggleLoader(false);
                    console.log(err)
                });
            // } else if ((steps === 2 || steps === 1) && localbizANDservicesId || adsIds) {
        } else if ((steps === 0 || steps === 1 || steps === 2) && (localbizANDservicesId || adsIds)) {

            toggleLoader(true);

            const updatedFetchConfig = fetchConfig;
            delete updatedFetchConfig.headers['Content-Type'];

            localBizAndServiceFormData.delete('accreditation_document');
            console.warn("created", steps)
            fetch(`${appURL}/posts/biz/edit/${localbizANDservicesId || adsIds}`, {
                ...updatedFetchConfig,
                method: "PATCH",
                body: data
            })

                .then(handleFetchErrors)
                .then((res) => {
                    localStorage.setItem('advertisementId', res.updatebizAdObjToSend.advertisement_id)
                    toggleLoader(false)
                    // if (res?.status === 200) {
                    //     updateSteps(steps + 1);
                    // } else {
                    //     return toast.error(res?.message);
                    // }
                    // Close any open modals before proceeding
                    setShowExitConfirmModal(false);
                    setShowDeleteModal(false);

                    // Show thank-you modal for active ads
                    // if (status === "active") {
                    //     setShowThankYouModal(true);
                    // } else {
                    //     updateSteps(steps + 1);
                    // }
                    if (steps === 2 && adsIds && status === "active") {
                        setShowThankYouModal(true);
                    } else if (steps !== 4) {
                        updateSteps(steps + 1);
                    }
                    const localObjectId = res?.updatebizAdObjToSend?._id;
                    updateLocalbizANDservicesId(localObjectId);

                })
                .catch((err) => {
                    toggleLoader(false);
                    console.log(err)
                });
        }
    };

    useEffect(() => {
        if (onLocalBizChange) {
            onLocalBizChange(localbizANDservicesId);
        }
    }, [localbizANDservicesId]);


    const handleFileChange = (event) => {
        const files = event.target.files;
        setSelectedFiles([...selectedFiles, ...files]);
    };
    

    const callBackFunction = (address = '', lat = '', lng = '') => {
        updateFormData({
            ...formData,
            location_name: address,
            latitude: lat,
            longitude: lng,
        });
    }


    // selecting location
    const callBackFunctionForPrimeLocation = (address = ``, lat = ``, lang = ``) => {
        updateFormData({
            ...formData,
            buisnesslocation: address
        })
    }

    // fetching ads categories
    const fetchingDynamicsData = () => {
        fetch(`${appURL}/posts/biz/dynamics-data?PostType=${"64e48f89f9eeb14b6e2135ba"}`, {
            ...fetchConfig,
            method: "GET"
        })
            .then(handleFetchErrors)
            .then((res) => {
                
                if (res.status === 200) {
                    const dynamicDataObj = res?.data;
                    if (dynamicDataObj) updateDynamicData(dynamicDataObj)

                } else {
                    return toast.error(`Enable fetch dynamics data`);
                }

            })
            .catch((err) => standardFetchHandlers.error(err));
    }

    // const backBtnClickHandler = () => {
    //     if (steps === 0) 
    //   return  toggleModalVisibilty("localBizServices", false);
    //         updateSteps(steps - 1);
    //     }


    const backBtnClickHandler = () => {
        if (steps === 0) {
            if (localbizANDservicesId) {

                setShowExitConfirmModal(true);
            } else {
                toggleModalVisibilty("localBizServices", false);
            }
        } else {
            updateSteps(steps - 1);
        }
    };

    useEffect(() => {
        console.log("step", steps)
    }, [steps])

    const [is24HoursSelected, toggleIs24HoursSelected] = useState({
        weekday: false,
        weekdend: false,
    })

    // handling week hour timing;
    const handlingWeekHours = (e, weekDayType) => {

        const inputChecked = e?.target?.checked,
            inputName = e?.target?.name;

        switch (weekDayType) {
            case "weekday":

                toggleIs24HoursSelected({
                    ...is24HoursSelected,
                    weekday: inputChecked,
                })

                if (inputChecked) {
                    updateWeekdayTime({
                        start: "",
                        end: "",
                    })
                }

                break;
            case "weekend":

                toggleIs24HoursSelected({
                    ...is24HoursSelected,
                    weekdend: inputChecked,
                })

                if (inputChecked) {
                    updateWeekedTime({
                        start: "",
                        end: "",
                    });
                }

                break;

            default:
                break;
        }


    }

    const onChangeForTime = (timeString, usedFor = "") => {
        // Extract the time part from the input string
        let timePart = timeString.toString().match(/\d{2}:\d{2}:\d{2}/)[0];
        let [hours, minutes, seconds] = timePart.split(':').map(Number);

        // Determine AM or PM
        let period = hours >= 12 ? 'PM' : 'AM';

        // Convert hours to 12-hour format
        hours = hours % 12 || 12; // Converts 0 hour to 12 for midnight

        // Format the hours and minutes to ensure they are two digits
        let formattedHours = hours.toString().padStart(2, '0');
        let formattedMinutes = minutes.toString().padStart(2, '0');

        // Construct the result string
        let result = `${formattedHours}:${formattedMinutes} ${period}`;

        switch (usedFor) {
            case "weekday_start_time":
            
                updateWeekdayTime({
                    ...weekdayTime,
                    start: result
                })
                break;

            case "weekday_end_time":
                updateWeekdayTime({
                    ...weekdayTime,
                    end: result,
                })
                break;


            case "weekend_end_time":
                updateWeekedTime({
                    ...weekedTime,
                    end: result,
                })
                break;


            case "weekend_start_time":
                updateWeekedTime({
                    ...weekedTime,
                    start: result,
                })
                break;

            default:
                break;
        }

    };

    const [isHideMobileNumberChecked, toggleIsHideMobileNumberChecked] = useState(false),
        [isHideEmailAddressChecked, toggleIsHideEmailAddressChecked] = useState(false),
        [isHideEmailAddress1Checked, toggleIsHideEmailAddress1Checked] = useState(false);


    // lister info
    // const hideEmailNumberSwitchButtonHandler = (e) => {

    //     const inputName = e?.target?.name;

    //     if (inputName === `hide_secondary_phone_number`) toggleIsHideEmailAddressChecked(!isHideEmailAddressChecked)
    //     if (inputName === `hide_primary_phone_number`) toggleIsHideMobileNumberChecked(!isHideMobileNumberChecked)
    //     if (inputName === `hide_my_email_address`) toggleIsHideEmailAddress1Checked(!isHideEmailAddress1Checked)

    // }
    const hideEmailNumberSwitchButtonHandler = (e) => {
        const inputName = e?.target?.name;

        if (inputName === `hide_email_address`)  // Changed this line
            toggleIsHideEmailAddressChecked(!isHideEmailAddressChecked);
        if (inputName === `hide_phone_number`)  // Changed this line
            toggleIsHideMobileNumberChecked(!isHideMobileNumberChecked);
        if (inputName === `hide_my_email_address`)
            toggleIsHideEmailAddress1Checked(!isHideEmailAddress1Checked);
    };

    let HeadingMessage = `Post your Ad`;
    let SubHeadingMessage = ``;

    if (steps === 3) {
        HeadingMessage = `Post your Ad`
    } else if (steps === 4) {
        SubHeadingMessage = ``
        HeadingMessage = ''
    } else if (steps === 2) {
        SubHeadingMessage = `  Basic Information`
    }

    // accreditation 
    const handlingAddRemoveAccreditationCard = (action = null, id = null) => {
        toast.dismiss();

        if (accreditationLists?.length !== 0 && action === 1) {
            const isDataIncomplete = accreditationLists.some(
                accreditation => !accreditation.name || !accreditation.file_name || !accreditation.image_file_obj
            );

            if (isDataIncomplete) {
                return toast.error(`file and name are required for all accreditation.`)
            }
        }

        if (action === 1) {
            const newExperience = {
                id: cuid(),
                name: "",
                file_name: "",
                file_type: "",
                image_file_obj: null
            };
            updateAccreditationLists([...accreditationLists, newExperience]);
        } else if (action === 2) {
            updateAccreditationLists(prevLists => prevLists.filter(item => item.id !== id));
        }
    }


    // Create the file input element once
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = false;
    // input.accept = '.doc, .docx, .pdf, .xls, .xlsx, image/*'; // Specify accepted file extensions and images
    input.accept = '.pdf, image/*'; // Specify accepted file extensions and images

    const onClickHandlerForAccreditationUpload = (id) => {
        input.onchange = (e) => {
            const fileObj = e?.target?.files?.[0];
            const file_name = fileObj?.name;
            const fileTypeArr = file_name.split(`.`);
            const file_type = fileTypeArr?.length ? fileTypeArr[fileTypeArr.length - 1] : ``;

            // Check if the file type is allowed (Word, PDF, or Excel)
            // if (['doc', 'docx', 'pdf', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif'].includes(file_type.toLowerCase())) {
            if (['pdf', 'jpg', 'png'].includes(file_type.toLowerCase())) {
                const index = accreditationLists.findIndex(item => item.id === id);
                if (index !== -1) {
                    const updatedList = [...accreditationLists];
                    updatedList[index] = {
                        ...updatedList[index],
                        file_name,
                        name: "",
                        file_type,
                        image_file_obj: fileObj
                    };
                    updateAccreditationLists(updatedList);
                }
            } else {
                // File type is not allowed, return an error message
                // return 'Invalid file type. Only Word, PDF, and Excel files are allowed.';
                toast.error('Invalid file type. Only JPG, PNG and PDF files are allowed.');
            }
        };
        input.click();
    };


    const handleChange1 = (e, id, fieldType) => {

        const index = accreditationLists.findIndex(item => item.id === id);
        const inputValue = e?.target.value;


        if (index !== -1) {
            const updatedList = [...accreditationLists];

            if (fieldType === 1) {
                const errorMessage = onClickHandlerForAccreditationUpload(id);
                if (errorMessage) {
                    return toast.error(errorMessage); // Handle the error message using toast or any other error notification method
                }
            } else if (fieldType === 2) {
                updatedList[index] = {
                    ...updatedList[index],

                    name: inputValue,
                };
            }
            updateAccreditationLists(updatedList);
        }
    };


    const fetchingAdsById = () => {
        let id = adsId || adsIds;
        
        fetch(`${appURL}/posts/biz/ad_details?adsId=${id}`, {
            ...fetchConfig,
            method: "GET"
        })
            .then(handleFetchErrors)
            .then((res) => {
            

                if (res?.status == 200) {
                    const data = res?.ads_details,
                        listerInfo = data?.lister_basic_info,
                        adsInfo = data?.adsInfo;
                    setTags(adsInfo?.tagline);
                    setupdateCat(adsInfo?.categories?.name);
                    updateSubCat(adsInfo?.sub_categories?.name)
                    setSelectedFiles(res?.ads_details?.adsInfo?.image);
                    setmyadsId(res?.ads_details?._id);
                    setmyadsType(res?.ads_details?.adsType);

                    if (adsInfo && adsInfo?.working_hours && adsInfo?.working_hours?.week_days) {
                        toggleIs24HoursSelected(prevState => ({
                            ...prevState,
                            weekday: adsInfo?.working_hours?.week_days.is_24_hour
                        }));
                        setforStartSend(adsInfo.working_hours.week_days?.open_at);
                        setforEndSend(adsInfo.working_hours.week_days?.open_at);
                        convertTimeToMomentEnd(adsInfo.working_hours.week_days?.close_at);
                        convertTimeToMoment(adsInfo.working_hours.week_days?.open_at);
                    }

                    if (adsInfo && adsInfo?.working_hours && adsInfo?.working_hours?.week_ends) {
                        toggleIs24HoursSelected(prevState => ({
                            ...prevState,
                            week_ends: adsInfo?.working_hours?.week_days?.is_24_hour
                        }));
                        convertTimeToMomentEndWeekday(adsInfo.working_hours.week_ends?.close_at);
                        convertTimeToMomentWeekday(adsInfo.working_hours.week_ends?.open_at);
                    }


                    if (adsInfo && adsInfo?.working_hours && adsInfo?.working_hours?.week_days && adsInfo && adsInfo?.working_hours && adsInfo?.working_hours?.week_ends) {
                    
                        toggleIs24HoursSelected(prevState => ({
                            weekday: adsInfo.working_hours.week_days.is_24_hour,
                            week_ends: adsInfo.working_hours.week_days.is_24_hour
                        }));
                        convertTimeToMomentEnd(adsInfo.working_hours.week_days?.close_at);
                        convertTimeToMoment(adsInfo.working_hours.week_days?.open_at);
                        convertTimeToMomentEndWeekday(adsInfo.working_hours.week_ends?.close_at);
                        convertTimeToMomentWeekday(adsInfo.working_hours.week_ends?.open_at);

                    }
                    toggleIsHideMobileNumberChecked(listerInfo?.hide_my_phone || false);
                    toggleIsHideEmailAddressChecked(listerInfo?.hide_my_secondary_phone || false);
                    
                    const dataObj = {
                        accreditation_file: adsInfo?.accreditation_file || "",
                        categories: adsInfo?.categories?.id || "",
                        sub_categories: adsInfo?.sub_categories?.id || "",
                        video_link: adsInfo?.video_link || "",
                        buisness_name: adsInfo?.title || "",
                        tagline: adsInfo?.tagline || [],
                        experience: adsInfo?.experience || "",
                        location_name: adsInfo?.location?.location_name,
                        latitude: adsInfo?.location?.coordinates[1],
                        longitude: adsInfo?.location?.coordinates[0],
                        title: adsInfo?.title,
                        claim: data?.userDetails?.claim ? data?.userDetails?.claim : false,
                        isClaimed: adsInfo?.isClaimed ? adsInfo?.isClaimed : false,
                        price: adsInfo?.category || "",
                        availabilty_type: adsInfo && adsInfo?.working_hours && adsInfo?.working_hours?.week_days?.is_available == true ? "1" : adsInfo && adsInfo?.working_hours && adsInfo?.working_hours?.week_ends?.is_available == true ? "2" : adsInfo && adsInfo?.working_hours && adsInfo?.working_hours?.is_24_seven == true ? "4" : adsInfo?.working_hours?.appointment == true ? "5" : "3",
                        // working_hours_weekDay : adsInfo?.working_hours?.week_days || "",
                        descriptions: adsInfo?.descriptions || "",
                        website_link: adsInfo?.website_url,
                        name: listerInfo?.name !== "" ? listerInfo?.name : JSON.parse(localStorage.getItem(`user`))?.name,
                        email_address: JSON.parse(localStorage.getItem(`user`))?.email_address,
                        country_code: listerInfo?.primary_mobile_number?.country_code || "+1",
                        secondary_country_code: listerInfo?.secondary_mobile_number?.country_code || "+1",
                        primary_phone_number: listerInfo?.primary_mobile_number?.primary_phone_number !== "" ? listerInfo?.primary_mobile_number?.primary_phone_number : JSON.parse(localStorage.getItem(`user`))?.phone_number,
                        secondary_phone_number: listerInfo?.secondary_mobile_number?.secondary_phone_number || "",
                        website: listerInfo?.webiste || "",
                        hide_secondary_phone_number: listerInfo?.hide_my_secondary_phone || false,
                        hide_primary_phone_number: listerInfo?.hide_my_phone || false,
                        adsType: data.adsType,
                        status: data.status,
                    }
                    updateFormData(dataObj)
                }
            })
            .catch((err) => {
                console.log(err)
            });
    }

    let times = {
        start: null,
        end: null
    };


    function convertTimeToMoment(timeString) {
        // Extract hour, minute, and period (AM/PM)
        const [time, period] = timeString.split(' ');
        let [hour, minute] = time.split(':');

        // Convert to integers to remove leading zeros
        hour = parseInt(hour, 10);
        minute = parseInt(minute, 10);

        // Convert to 24-hour format if PM and hour is not 12
        if (period === 'PM' && hour !== 12) {
            hour += 12;
        }

        // Handle 12 AM case
        if (period === 'AM' && hour === 12) {
            hour = 0;
        }

        // Use moment.js to set the time
        const startMoment = moment().hour(hour).minute(minute);
        

        // Update shared state
        times.start = startMoment;

        // Update weekday time with both start and end times
        updateWeekdayTime({
            start: times.start,
            end: times.end
        });
    }

    function convertTimeToMomentEnd(timeString) {
        // Extract hour, minute, and period (AM/PM)
        const [time, period] = timeString.split(' ');
        let [hour, minute] = time.split(':');

        // Convert to integers to remove leading zeros
        hour = parseInt(hour, 10);
        minute = parseInt(minute, 10);

        // Convert to 24-hour format if PM and hour is not 12
        if (period === 'PM' && hour !== 12) {
            hour += 12;
        }

        // Handle 12 AM case
        if (period === 'AM' && hour === 12) {
            hour = 0;
        }

        // Use moment.js to set the time
        const endMoment = moment().hour(hour).minute(minute);
       

        // Update shared state
        times.end = endMoment;

        // Update weekday time with both start and end times


        updateWeekedTime({
            start: times.start,
            end: times.end
        });
    }

    function convertTimeToMomentWeekday(timeString) {
        // Extract hour, minute, and period (AM/PM)
        const [time, period] = timeString.split(' ');
        let [hour, minute] = time.split(':');

        // Convert to integers to remove leading zeros
        hour = parseInt(hour, 10);
        minute = parseInt(minute, 10);

        // Convert to 24-hour format if PM and hour is not 12
        if (period === 'PM' && hour !== 12) {
            hour += 12;
        }

        // Handle 12 AM case
        if (period === 'AM' && hour === 12) {
            hour = 0;
        }

        // Use moment.js to set the time
        const startMoment = moment().hour(hour).minute(minute);
        

        // Update shared state
        times.start = startMoment;

        // Update weekday time with both start and end times
        updateWeekedTime({
            start: times.start,
            end: times.end
        });
    }

    function convertTimeToMomentEndWeekday(timeString) {
        // Extract hour, minute, and period (AM/PM)
        const [time, period] = timeString.split(' ');
        let [hour, minute] = time.split(':');

        // Convert to integers to remove leading zeros
        hour = parseInt(hour, 10);
        minute = parseInt(minute, 10);

        // Convert to 24-hour format if PM and hour is not 12
        if (period === 'PM' && hour !== 12) {
            hour += 12;
        }

        // Handle 12 AM case
        if (period === 'AM' && hour === 12) {
            hour = 0;
        }

        // Use moment.js to set the time
        const endMoment = moment().hour(hour).minute(minute);
       

        // Update shared state
        times.end = endMoment;

        // Update weekday time with both start and end times


        updateWeekedTime({
            start: times.start,
            end: times.end
        });
    }

    useEffect(() => {
        fetchingDynamicsData();
        if (adsId || adsIds) fetchingAdsById();
    }, [])


    const deleteAd = async () => {
        try {
            // First, verify we have a valid ad ID
            const adIdToDelete = adsIds || localbizANDservicesId; // Use the same ID sources as save function
            
            if (!adIdToDelete) {
                toast.error("No ad ID found to delete");
                return;
            }

            toggleLoader(true);

            // Use query parameter format as suggested by your endpoint
            const res = await fetch(`${appURL}/posts/biz/delete-ad?ads_id=${adIdToDelete}`, {
                ...fetchConfig,
                method: "DELETE",
            });

            const data = await res.json();
    

            toggleLoader(false);

            if (data?.status === 200) {
                toast.success("Ad deleted successfully");
                setShowDeleteModal(false);
                setShowExitConfirmModal(false);
                toggleModalVisibilty("localBizServices", false);

                // Clear any stored ad info from localStorage
                localStorage.removeItem('adsInfo');

                // setTimeout(() => {
                //     window.location.href = '/my-ads';
                // }, 1000);
            } else {
                toast.error(data?.message || "Failed to delete ad");
            }
        } catch (err) {
            toggleLoader(false);
            console.error("Error deleting ad:", err);
            toast.error("Something went wrong while deleting ad");
        }
    };


    return (
        <main className={style.main_wrapper}>

            <Modal show={showExitConfirmModal} onHide={() => setShowExitConfirmModal(false)} centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>Save as draft or delete your ad?</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={() => {
                            setShowExitConfirmModal(false);
                            setShowSaveDraftModal(true);
                        }}
                        style={{
                            backgroundColor: '#FFF0E5', // Light shade of #FD7E14
                            color: '#FD7E14', // Text color matches main orange
                            borderColor: '#FD7E14' // Border matches text
                        }}
                    >
                        Save as Draft
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => {
                            setShowExitConfirmModal(false);
                            setShowDeleteModal(true);
                        }}
                        style={{
                            backgroundColor: '#FD7E14',
                            borderColor: '#FD7E14',
                            color: 'white' // White text
                        }}
                    >
                        Delete your ad
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showSaveDraftModal} onHide={() => setShowSaveDraftModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Save as Draft</Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you want to save this ad as a draft?</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="light"
                        onClick={() => setShowSaveDraftModal(false)}
                        style={{
                            backgroundColor: '#FFF0E5',
                            color: '#FD7E14',
                            borderColor: '#FD7E14'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={async () => {
                            setShowSaveDraftModal(false);
                            // window.location.reload();
                            // await saveDraftAndExit();
                        }}
                        style={{
                            backgroundColor: '#FD7E14',
                            borderColor: '#FD7E14',
                            color: 'white'
                        }}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this draft post permanently?</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="light"
                        onClick={() => setShowDeleteModal(false)}
                        style={{
                            backgroundColor: '#FFF0E5',
                            color: '#FD7E14',
                            borderColor: '#FD7E14'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={async () => {
                            setShowDeleteModal(false);
                            await deleteAd();
                            // window.location.reload();
                        }}
                        style={{
                            backgroundColor: '#FD7E14',
                            borderColor: '#FD7E14',
                            color: 'white'
                        }}
                    >
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Add this after your existing modals */}
            <ThankYouModal
                show={showThankYouModal}
                onClose={() => {
                    setShowThankYouModal(false);
                    toggleModalVisibilty("localBizServices", false);
                    // Optional: refresh the page or parent component
                    window.location.reload();
                }}
                message="Ad Updated Successfully!"
                subMessage="Your local business advertisement has been updated successfully."
            />

            <PostAdsHeading
                headingText={
                    steps === 2 && status === 'active' ? 'Update Your Ad' : HeadingMessage
                }
                subHeadingText={SubHeadingMessage}
            />

            <form id={steps === 3 ? undefined : style.room_rents_form}>
                {
                    (() => {
                        if (steps === 0) {
                            return (
                                <>
                                    {
                                        <Inputs
                                            name='categories'
                                            required={true}
                                            value={categories}
                                            defaultValue={updateCat || ""}
                                            onChangeHandler={onChangeHandlerForForm}
                                            label='Category'
                                            type='select'
                                            id="span-2"
                                            placeholder='Select category'
                                            selectInputOptions={dynamicData?.categories}
                                        // disabled={status !== "draft" && (adsIds ? true : false)}
                                        />
                                    }

                                    {
                                        (categories && subCategory?.length) ?
                                            <Inputs
                                                name='sub_categories'
                                                id="span-2"
                                                required={true}
                                                value={sub_categories}
                                                defaultValue={subCat || ""}
                                                onChangeHandler={onChangeHandlerForForm}
                                                label={`Sub-category`}
                                                // disabled={status !== "draft" && (adsIds ? true : false)}
                                                type='select'
                                                placeholder={`Select Sub-category`}
                                                selectInputOptions={subCategory ? subCategory : ``}
                                            /> : ``
                                    }

                                    <Inputs
                                        name='experience'
                                        value={experience}
                                        onChangeHandler={onChangeHandlerForForm}
                                        label='Business Experience'
                                        type='select'
                                        id='span-2'
                                        disabled={status !== "draft" && (adsIds ? true : false)}
                                        required={true}
                                        placeholder='Select business experience'
                                        selectInputOptions={dynamicData?.buisness_experience}
                                    />

                                    <Inputs
                                        name='buisness_name'
                                        required={true}
                                        id='span-2'
                                        value={buisness_name}
                                        onChangeHandler={onChangeHandlerForForm}
                                        label='Title'
                                        type='text'
                                        placeholder='Enter title'
                                    />

                                    <section id="span-2">
                                        <div>
                                            <label className="tagline-main">Business tagline</label>
                                            <div>
                                                <input
                                                    type="text"
                                                    name="tagline"
                                                    value={inputValue}
                                                    onChange={handleTagInputChange}
                                                    onKeyPress={handleKeyPress}
                                                    placeholder="Enter tagline"
                                                />
                                                <button onClick={handleAddTag} style={{ display: "none" }} >Add Tag</button>
                                            </div>

                                            {/* Display tags */}
                                            <div>
                                                {tags.length > 0 && (
                                                    <div>
                                                        {tags.map((tag, index) => (
                                                            <span key={index} style={{ margin: "5px", padding: "5px", border: "1px solid #ccc", display: "inline-block" }}>
                                                                {tag}
                                                                <button
                                                                    onClick={() => handleRemoveTag(tag)}
                                                                    style={{ marginLeft: "5px", cursor: "pointer", background: "red", color: "white", border: "none", borderRadius: "50%", width: "20px", height: "20px" }}
                                                                >
                                                                    ×
                                                                </button>
                                                            </span>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Display message if the limit is exceeded */}
                                            {inputValue.length > 25 && <p style={{ color: 'red' }}>Tag must be less than 25 characters</p>}
                                        </div>
                                    </section>

                                    <SelectLocation callBackFunction={callBackFunction}
                                        location={location_name}
                                        latitude={latitude}
                                        longitude={longitude}
                                        //    abc={abcfunction} 
                                        locationResponseData={locationResponseData}
                                        setLocationResponseData={setLocationResponseData}
                                        required={true} />
                                </>
                            )
                        } else if (steps === 1) {
                            return (
                                <>
                                    <Inputs
                                        label='Select your availabilty'
                                        type='radio'
                                        required={true}
                                        name='availabilty_type'
                                        id='span-2'
                                        value={availabilty_type}
                                        onChangeHandler={onChangeHandlerForForm}
                                        radioBtnOtions={radioBtnOption}
                                    />

                                    {
                                        (availabilty_type === "1" || availabilty_type === "3") &&
                                        <section id='span-2' className={style.working_hours_wrapper}>

                                            <div className={style.working_hours_close_text_wrapper}>


                                                <span className={style.working_hours_label}>Weekdays</span>
                                                {
                                                    <div className={style.checkbox_for_24_hours} >
                                                        <input checked={is24HoursSelected.weekday} name='24_hours' onChange={(e) => handlingWeekHours(e, "weekday")} type="checkbox" id="weekday" />
                                                        <label htmlFor="weekday">24 hours</label><br />
                                                    </div>
                                                }
                                            </div>

                                            <div className={style.start_end_time_wrapper}>

                                                <TimePicker
                                                    showSecond={false}
                                                    className="xxx"
                                                    defaultValue={weekdayTime?.start}
                                                    use12Hours
                                                    inputReadOnly
                                                    onChange={(item) => { onChangeForTime(item?._d, "weekday_start_time") }}
                                                />

                                                <TimePicker
                                                    showSecond={false}
                                                    className="xxx"
                                                    defaultValue={weekdayTime?.end}
                                                    use12Hours
                                                    inputReadOnly
                                                    onChange={(item) => { onChangeForTime(item?._d, "weekday_end_time") }}
                                                />

                                            </div>
                                        </section>
                                    }

                                    {
                                        (availabilty_type === "2" || availabilty_type === "3") &&
                                        <section id='span-2' className={style.working_hours_wrapper}>
                                            <div className={style.working_hours_close_text_wrapper}>
                                                <span className={style.working_hours_label}>Weekends</span>
                                                {
                                                    <div className={style.checkbox_for_24_hours} >
                                                        <input checked={is24HoursSelected.weekdend} name='24_hours' onChange={(e) => handlingWeekHours(e, "weekend")} type="checkbox" id="weekend" />
                                                        <label htmlFor="weekend">24 hours</label><br />
                                                    </div>
                                                }
                                            </div>
                                            <div className={style.start_end_time_wrapper}>
                                                <TimePicker
                                                    showSecond={false}
                                                    className="xxx"
                                                    defaultValue={weekedTime?.start}
                                                    use12Hours
                                                    inputReadOnly
                                                    onChange={(item) => { onChangeForTime(item?._d, "weekend_start_time") }}
                                                    disabled={is24HoursSelected?.weekdend}
                                                />

                                                <TimePicker
                                                    showSecond={false}
                                                    className="xxx"
                                                    defaultValue={weekedTime?.end}
                                                    use12Hours
                                                    inputReadOnly
                                                    onChange={(item) => { onChangeForTime(item?._d, "weekend_end_time") }}
                                                    disabled={is24HoursSelected?.weekdend}
                                                />
                                            </div>
                                        </section>
                                    }

                                    <Inputs
                                        label='Youtube video link'
                                        id='span-2'
                                        type='text'
                                        name='video_link'
                                        value={video_link}
                                        onChangeHandler={onChangeHandlerForForm}
                                        placeholder='https://www.youtube.com/'
                                    />

                                    <RichTextEditor value={descriptions} updateFormData={updateFormData} formData={formData} label="Description" required={true} />

                                    <section id='span-2'>
                                        {
                                            <div className={style.heading_add_more_bt_section}>
                                                <p id='label'>Add Accreditation<span className='optional_text'>(Optional)</span></p>
                                                {
                                                    accreditationLists?.length < 4 &&
                                                    <div onClick={() => { handlingAddRemoveAccreditationCard(1, null) }} className={style.add_more_button}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                                    </div>
                                                }
                                            </div>
                                        }


                                        <div className={style.upload_accreditation_section_wrapper}>
                                            {
                                                accreditationLists?.length ? accreditationLists.map((accreditation, i) => {

                                                    return (
                                                        <div key={i} className={style.upload_accreditation_section}>

                                                            {
                                                                accreditation?.file_type ?

                                                                    <div onClick={() => { onClickHandlerForAccreditationUpload(accreditation.id) }} className={style.image_icon}>
                                                                        <span className={style.file_type_text}>
                                                                            {
                                                                                (() => {
                                                                                    if (String(accreditation?.file_type).toLocaleLowerCase() == "pdf") {

                                                                                        return <svg width="30" height="30" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <path d="M19.6159 5.00678C19.9676 5.35849 20.1652 5.83552 20.1652 6.33292V22.2676C20.1652 23.3034 19.3255 24.1431 18.2897 24.1431H1.87545C0.83967 24.1431 0 23.3034 0 22.2676V1.87569C0 0.839912 0.839668 0.000244141 1.87545 0.000244141H13.8325C14.33 0.000244141 14.807 0.19784 15.1587 0.549563L17.1971 2.58802L19.6159 5.00678Z" fill="#FF6521" />
                                                                                            <path opacity="0.08" d="M20.1652 5.55593V24.1429H0V19.785L9.42677 10.3582L9.98484 9.80013L10.2941 9.49085L10.8095 8.97545L11.4209 8.36405L17.1971 2.58786L20.1652 5.55593Z" fill="#FF6521" />
                                                                                            <path d="M20.0765 5.42986C20.1555 5.50887 20.0995 5.64397 19.9878 5.64397H14.772C14.7028 5.64397 14.6466 5.58781 14.6466 5.51854V0.302794C14.6466 0.191055 14.7817 0.135097 14.8607 0.214108L20.0765 5.42986Z" fill="#FF9A6D" />
                                                                                            <path d="M17.1605 13.9837C16.7963 13.5748 15.987 13.3704 14.8943 13.3704C14.2469 13.3704 13.5589 13.4522 12.7496 13.5748C11.8926 12.764 11.1807 11.8097 10.6452 10.7541C11.0499 9.52762 11.3332 8.34207 11.3332 7.44269C11.3332 6.74771 11.0904 5.64392 10.1192 5.64392C9.83589 5.64392 9.59308 5.80745 9.43121 6.05273C9.02653 6.78859 9.1884 8.42383 9.95729 10.1408C9.39563 11.7815 8.71947 13.3799 7.93391 14.9239C5.78913 15.8233 4.37276 16.8044 4.25136 17.5812C4.17042 17.9491 4.41323 18.5623 5.26305 18.5623C6.51754 18.5623 7.89344 16.7227 8.9456 14.8422C10.1602 14.4202 11.4048 14.0922 12.6686 13.861C14.2064 15.2101 15.5418 15.4145 16.1893 15.4145C17.4843 15.4145 17.6057 14.4742 17.1605 13.9837ZM9.63355 6.17537C9.95729 5.6848 10.6857 5.84833 10.6857 6.82947C10.6857 7.48357 10.4834 8.54647 10.0787 9.77291C9.35027 8.0559 9.35027 6.70683 9.63355 6.17537ZM4.49416 17.6221C4.61557 16.968 5.82959 16.0686 7.73157 15.2918C6.67941 17.0906 5.62726 18.2353 4.97977 18.2353C4.5751 18.2353 4.4537 17.8674 4.49416 17.6221ZM12.4663 13.6157C11.326 13.8304 10.2033 14.131 9.10747 14.5151C9.70643 13.423 10.1945 12.2725 10.5643 11.0811C11.0962 11.9994 11.7347 12.8503 12.4663 13.6157ZM12.9924 13.7792C14.2873 13.5748 15.3799 13.6157 15.8656 13.6975C17.0391 13.9428 16.6344 15.3736 15.3395 15.0466C14.4087 14.8422 13.6398 14.3107 12.9924 13.7792Z" fill="white" />
                                                                                        </svg>


                                                                                    } else if (String(accreditation?.file_type).toLocaleLowerCase() == "docx") {

                                                                                        return <svg width="30" height="30" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <path d="M19.6159 5.00678C19.9676 5.35849 20.1652 5.83552 20.1652 6.33292V22.2676C20.1652 23.3034 19.3255 24.1431 18.2897 24.1431H1.87545C0.83967 24.1431 0 23.3034 0 22.2676V1.87569C0 0.839912 0.839668 0.000244141 1.87545 0.000244141H13.8325C14.33 0.000244141 14.807 0.19784 15.1587 0.549563L17.1971 2.58802L19.6159 5.00678Z" fill="#FF6521" />
                                                                                            <path opacity="0.08" d="M20.1652 5.55593V24.1429H0V19.785L9.42677 10.3582L9.98484 9.80013L10.2941 9.49085L10.8095 8.97545L11.4209 8.36405L17.1971 2.58786L20.1652 5.55593Z" fill="#FF6521" />
                                                                                            <path d="M20.0765 5.42986C20.1555 5.50887 20.0995 5.64397 19.9878 5.64397H14.772C14.7028 5.64397 14.6466 5.58781 14.6466 5.51854V0.302794C14.6466 0.191055 14.7817 0.135097 14.8607 0.214108L20.0765 5.42986Z" fill="#FF9A6D" />
                                                                                            <path d="M12.1879 15.1432L13.3116 9.00075H15.6533L13.5742 18.7962H11.1253L9.81323 13.2119L8.528 18.7962H6.08599L4 9H6.34783L7.4716 15.1424L8.81732 9H10.8222L12.1879 15.1432Z" fill="white" />
                                                                                        </svg>


                                                                                    } else if (String(accreditation?.file_type).toLocaleLowerCase() == "xlsx") {

                                                                                        return <svg width="30" height="30" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <path d="M19.6159 5.00678C19.9676 5.35849 20.1652 5.83552 20.1652 6.33292V22.2676C20.1652 23.3034 19.3255 24.1431 18.2897 24.1431H1.87545C0.83967 24.1431 0 23.3034 0 22.2676V1.87569C0 0.839912 0.839668 0.000244141 1.87545 0.000244141H13.8325C14.33 0.000244141 14.807 0.19784 15.1587 0.549563L17.1971 2.58802L19.6159 5.00678Z" fill="#FF6521" />
                                                                                            <path opacity="0.08" d="M20.1652 5.55593V24.1429H0V19.785L9.42677 10.3582L9.98484 9.80013L10.2941 9.49085L10.8095 8.97545L11.4209 8.36405L17.1971 2.58786L20.1652 5.55593Z" fill="#FF6521" />
                                                                                            <path d="M20.0765 5.42986C20.1555 5.50887 20.0995 5.64397 19.9878 5.64397H14.772C14.7028 5.64397 14.6466 5.58781 14.6466 5.51854V0.302794C14.6466 0.191055 14.7817 0.135097 14.8607 0.214108L20.0765 5.42986Z" fill="#FF9A6D" />
                                                                                            <path d="M6.45875 9.7L5.25275 11.824L4.07375 9.7H2.78675L4.65875 12.724L2.56175 16H3.84875L5.24375 13.579L6.59375 16H7.88975L5.84675 12.724L7.75475 9.7H6.45875ZM8.66733 9.7V16H12.2313V15.046H9.72933V9.7H8.66733ZM13.4143 13.966L12.6223 14.524C12.7603 14.812 12.9463 15.079 13.1803 15.325C13.4203 15.571 13.6963 15.769 14.0083 15.919C14.3263 16.063 14.6683 16.135 15.0343 16.135C15.3043 16.135 15.5623 16.09 15.8083 16C16.0603 15.916 16.2853 15.796 16.4833 15.64C16.6813 15.478 16.8373 15.28 16.9513 15.046C17.0713 14.812 17.1313 14.548 17.1313 14.254C17.1313 13.978 17.0833 13.738 16.9873 13.534C16.8913 13.324 16.7653 13.144 16.6093 12.994C16.4593 12.844 16.2883 12.718 16.0963 12.616C15.9103 12.514 15.7213 12.43 15.5293 12.364C15.1933 12.244 14.9203 12.127 14.7103 12.013C14.5003 11.899 14.3443 11.779 14.2423 11.653C14.1463 11.521 14.0983 11.374 14.0983 11.212C14.0983 11.032 14.1673 10.876 14.3053 10.744C14.4433 10.606 14.6593 10.537 14.9533 10.537C15.1633 10.537 15.3463 10.579 15.5023 10.663C15.6643 10.741 15.8053 10.849 15.9253 10.987C16.0453 11.119 16.1473 11.263 16.2313 11.419L17.0863 10.933C16.9843 10.711 16.8373 10.498 16.6453 10.294C16.4533 10.09 16.2193 9.922 15.9433 9.79C15.6673 9.652 15.3433 9.583 14.9713 9.583C14.5933 9.583 14.2543 9.655 13.9543 9.799C13.6603 9.943 13.4263 10.144 13.2523 10.402C13.0783 10.654 12.9913 10.948 12.9913 11.284C12.9913 11.578 13.0483 11.83 13.1623 12.04C13.2763 12.244 13.4203 12.418 13.5943 12.562C13.7683 12.7 13.9513 12.817 14.1433 12.913C14.3353 13.003 14.5093 13.075 14.6653 13.129C14.9293 13.225 15.1633 13.324 15.3673 13.426C15.5713 13.522 15.7273 13.642 15.8353 13.786C15.9493 13.924 16.0063 14.107 16.0063 14.335C16.0063 14.587 15.9163 14.791 15.7363 14.947C15.5563 15.103 15.3223 15.181 15.0343 15.181C14.8003 15.181 14.5843 15.13 14.3863 15.028C14.1943 14.926 14.0173 14.785 13.8553 14.605C13.6993 14.425 13.5523 14.212 13.4143 13.966Z" fill="white" />
                                                                                        </svg>

                                                                                    } else {
                                                                                        <span className={style.click_to_upload_btn_text}>{accreditation?.file_type}</span>
                                                                                    }
                                                                                })()
                                                                            }

                                                                        </span>
                                                                        <span id={style.file_name_text} className={style.click_to_upload_btn_text}>{accreditation?.file_name}</span>
                                                                    </div>
                                                                    :

                                                                    <div onClick={() => { onClickHandlerForAccreditationUpload(accreditation.id) }} className={style.image_icon}>

                                                                        <svg width="30" height="30" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M9.87502 10.4167C11.0256 10.4167 11.9584 9.48393 11.9584 8.33333C11.9584 7.18274 11.0256 6.25 9.87502 6.25C8.72443 6.25 7.79169 7.18274 7.79169 8.33333C7.79169 9.48393 8.72443 10.4167 9.87502 10.4167Z" stroke="#FF6521" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />
                                                                            <path d="M14.0416 2.08334H9.87498C4.66665 2.08334 2.58331 4.16668 2.58331 9.37501V15.625C2.58331 20.8333 4.66665 22.9167 9.87498 22.9167H16.125C21.3333 22.9167 23.4166 20.8333 23.4166 15.625V10.4167" stroke="#FF6521" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />
                                                                            <path d="M16.9062 5.20834H22.6354" stroke="#FF6521" strokeWidth="1.5625" strokeLinecap="round" />
                                                                            <path d="M19.7708 8.07292V2.34375" stroke="#FF6521" strokeWidth="1.5625" strokeLinecap="round" />
                                                                            <path d="M3.28125 19.7396L8.41667 16.2917C9.23958 15.7396 10.4271 15.8021 11.1667 16.4375L11.5104 16.7396C12.3229 17.4375 13.6354 17.4375 14.4479 16.7396L18.7812 13.0208C19.5937 12.3229 20.9063 12.3229 21.7188 13.0208L23.4167 14.4792" stroke="#FF6521" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>


                                                                        <span className={style.click_to_upload_btn_text}>Click here to upload your pdf or image document file</span>
                                                                    </div>


                                                            }
                                                            <input
                                                                type="text"
                                                                name={accreditation?.id}
                                                                required={true}
                                                                onChange={(e) => { handleChange1(e, accreditation?.id, 2) }}
                                                                value={accreditation?.name}

                                                                placeholder={`Enter Document Name`}

                                                            />
                                                            {/* <input id={style.name_input} placeholder='Enter accreditation name' type="text" /> */}
                                                            <span onClick={() => { handlingAddRemoveAccreditationCard(2, accreditation?.id) }} className={style.closs_icon}>  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="#FD7E14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span>


                                                        </div>
                                                    )
                                                }) : ``
                                            }

                                        </div>
                                    </section>


                                    <ImageUpload images={images} updateImage={updateImage} handleFileChange={handleFileChange} setSelectedFiles={setSelectedFiles}
                                        selectedFiles={selectedFiles} myadsId={myadsId} myadsType={myadsType} />
                                </>
                            )

                        } else if (steps === 2) {
                            return <AdsListerInfo
                                onChangeHandler={onChangeHandlerForForm}
                                formData={formData}
                                isHideMobileNumberChecked={isHideMobileNumberChecked}
                                isHideEmailAddressChecked={isHideEmailAddressChecked}
                                isHideEmailAddress1Checked={isHideEmailAddress1Checked}
                                hideEmailNumberSwitchButtonHandler={hideEmailNumberSwitchButtonHandler}
                            />
                        }
                        else if (steps === 3 && !adsIds) {
                            return <AdsPlansUpdated
                                steps={steps}
                                updateSteps={updateSteps}
                                adsId={localbizANDservicesId}
                                adsCategoriesId={adsCategoriesId} />
                        }
                        else if (steps === 3 && adsIds && status != "active") {
                            return <AdsPlansUpdated steps={steps}
                                updateSteps={updateSteps}
                                adsId={localbizANDservicesId}
                                adsCategoriesId={adsCategoriesId || adsType}
                                adsIds={adsIds} />
                        }

                        else if (steps === 4) {
                            return <CongratulationsScreen />
                        }

                    })()
                }

                {/* {(steps !== 4 && steps !== 3) &&
                    <FormButton
                        cancelButtonText='Back'
                        submitBtnText={(steps === 2 && status === 'active') ? "Update My Ad" : (steps === 3 && status === 'draft') ? "Post My Ad" : "Next"}
                        id="span-2"
                        className={style.form_button_section}
                        backBtnClickHandler={backBtnClickHandler}
                        onClickHandler={handleFormSubmit}
                        showLoadder={showLoader}
                    />} */}
                {(steps !== 4 && steps !== 3) &&
                    <FormButton
                        cancelButtonText={(steps === 0 && adsIds) ? null : 'Back'}
                        submitBtnText={(steps === 2 && status === 'active') ? "Update My Ad" : (steps === 3 && status === 'draft') ? "Post My Ad" : "Next"}
                        id="span-2"
                        className={style.form_button_section}
                        backBtnClickHandler={backBtnClickHandler}
                        onClickHandler={handleFormSubmit}
                        showLoadder={showLoader}
                    />}

            </form>

        </main>
    )
}